import 'pixi-sound';
import { Collection } from '../../../Tiles/TileSet';
import { getSpriteId } from '../../../Utils/CollectableUtils';
import { TileGoldIdle } from '../../Animations/TileGoldIdle';
import { BoardSprite } from './BoardSprite';

export class GoldTile extends BoardSprite {
    public static TILE_SELECT_TIME: number = 200;
    public static TILE_MATCH_TIME: number = 400;

    constructor(tileSize: [number, number], collection: Collection) {
        super(getSpriteId('tile-gold', collection), tileSize, collection);

        const { width, height } = this;
        const sparkle = new TileGoldIdle([width, height]);
        this.addChild(sparkle);

        this.isAvailable = true;
        this.interactive = true;
        this.isMatched = false;
        this.spriteId = 'gold-0';
    }
}
